export default __webpack_public_path__ + "static/flower-de0f99fe46f8cce4dd33cbe2c8d79bf4.png";